import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiError } from '@/modules/common/hooks/use-api-error';
import { CreatedEntity } from '@/modules/common/types/created-entity';
import { invalidateClientRelatedQueries } from '@/modules/common/utils/query-invalidation';

import { createClient } from '../api/clients.api';
import { PaymentTermsDTO } from '../types/dto/payment-terms.dto';
import { CreateClientRequest } from '../types/dto/request/create-client.dto';

export interface CreateClientMinimalParams {
  name: string;
}

const buildMinimalCreateRequest = ({ name }: CreateClientMinimalParams): CreateClientRequest => ({
  info: {
    name,
    defaultPaymentTerms: PaymentTermsDTO.NET_30,
    email: '',
    managerId: null,
    billTo: '',
    shipTo: '',
  },
});

export const useCreateClient = () => {
  const queryClient = useQueryClient();
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation<CreatedEntity, unknown, CreateClientMinimalParams>({
    mutationFn: params => createClient(buildMinimalCreateRequest(params)),
    onSuccess: async () => {
      await invalidateClientRelatedQueries(queryClient);
    },
    onError: error => {
      displayToastErrorFromApiWithFallback(error, 'authenticated.clients:toasts.createClientError');
    },
  });
};
